module.exports = __webpack_public_path__ + "static/media/launchNew.10d48633.png";